// Edit My Profile Tab Start
export const TAB_GENERAL = "general";
export const TAB_SECURITY = "security";
export const TAB_NOTIFICATION = "notification";
//Edit My Profile Tab End
